import Select from 'react-select';
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import useLookupTaxType from '@hooks/Lookups/use-Lookup-TaxType';
import { AddTaxManagers, GetTaxManagersList } from '@store/Finance/TaxManagers/TaxManagerSlice';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
import { TaxManagersSchema } from '../../../ValidationForm/validationSchema';

import useGetTaxCategory from '@hooks/Lookups/use-Get_TaxCategory';

const AddVAT = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();
  const { TaxCategory, loading: loading2, error: error2 } = useGetTaxCategory();

  const { OptionsAccounts } = useGetAccounts();

  const { TAX_TYPE } = useLookupTaxType();

  const formik = useFormik({
    initialValues: {
      taxType: '',
      accountId: '',
      taxRate: 0,
      enabledFlag: true,
      startDateActive: '',
      taxCategory: ''
    },
    enableReinitialize: true,
    validationSchema: TaxManagersSchema(t),
    onSubmit: values => {
      dispatch(
        AddTaxManagers({
          taxType: values.taxType,
          taxRate: values.taxRate,
          taxCategory: values.taxCategory,
          enabledFlag: values.enabledFlag,
          startDateActive: values.startDateActive,
          // endDateActive: values.endDateActive,
          accountId: values.accountId
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            document.getElementById('closeModalForm')?.click();
            formik.resetForm();
            dispatch(GetTaxManagersList());
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  console.log(formik.errors);

  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        <div className='row'>
          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('TaxType')}</label>
              <Form.Select
                className='form-select text-center'
                name='taxType'
                value={formik.values.taxType}
                onChange={formik.handleChange}
                isInvalid={!!(formik.touched.taxType && formik.errors.taxType)}
              >
                <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {TAX_TYPE &&
                  TAX_TYPE?.map((item: any, idx: any) =>
                    item.list?.map((list: any) => (
                      <option key={++idx} value={list.lookupCode}>
                        {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                      </option>
                    ))
                  )}
              </Form.Select>
              <div className='text-danger small'>{formik.touched.taxType && formik.errors.taxType}</div>
            </div>
          </div>
          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('TaxRate')}</label>
              <div className='input-group flex-nowrap'>
                <Form.Control
                  className='form-control text-center'
                  type='text'
                  autoComplete='off'
                  name='taxRate'
                  onChange={formik.handleChange}
                  value={formik.values.taxRate}
                  isInvalid={!!(formik.touched.taxRate && formik.errors.taxRate)}
                />
                <span className='input-group-text text-theme fw-bold'>%</span>
              </div>
              <div className='text-danger small'>{formik.touched.taxRate && formik.errors.taxRate}</div>
            </div>
          </div>
          <div className='col-xl-12'>
            <div className='form-group mb-3'>
              <label className='form-label required-field'>{t('TaxCategory')}</label>
              <Form.Select
                className='form-select'
                name='taxCategory'
                onChange={formik.handleChange}
                value={formik.values.taxCategory}
                isInvalid={!!(formik.touched.taxCategory && formik.errors.taxCategory)}
              >
                <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {TaxCategory &&
                  TaxCategory?.map((item: any, idx: number) =>
                    item.list?.map((list: any) => (
                      <option key={++idx} value={list.lookupCode}>
                        {i18n.language === 'en' ? list.meaning : list.meaning2}
                      </option>
                    ))
                  )}
              </Form.Select>
              <Form.Control.Feedback type='invalid'>{formik.errors.taxCategory}</Form.Control.Feedback>
            </div>
          </div>

          <div className='col-xl-12'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Account')}</label>
              <Select
                classNamePrefix='react-select'
                // className="text-center"
                // isLoading={loadingAccounts}
                isSearchable={true}
                isClearable
                options={OptionsAccounts}
                value={OptionsAccounts?.find(f => f.value === formik.values.accountId)}
                onChange={option => formik.setFieldValue('accountId', option?.value)}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
              />
              <div className='text-danger small'>{formik.touched.accountId && formik.errors.accountId}</div>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group'>
              <label className='form-label'>{t('StartDate')}</label>
              <Form.Control
                className='form-control text-center'
                type='date'
                name='startDateActive'
                onChange={formik.handleChange}
                value={formik.values.startDateActive}
                isInvalid={!!(formik.touched.startDateActive && formik.errors.startDateActive)}
              />
              <div className='text-danger small'>{formik.touched.startDateActive && formik.errors.startDateActive}</div>
            </div>
          </div>

          <div className='col-xl-6'>
            <div className='form-group mb-2'>
              <Form.Check
                style={{ margin: '10px 20px' }}
                className='pt-3'
                type='checkbox'
                label={t('Active')}
                name='enabledFlag'
                checked={formik.values.enabledFlag}
                onChange={formik.handleChange}
              />
            </div>
          </div>
        </div>

        <div className='text-center mt-3'>
          <div className='d-flex justify-content-between gap-2'>
            <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100 rounded-0'>
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
              )}
              {t('Add')}
            </button>
            <button
              type='button'
              className='btn btn-lg  btn-default mb-1 w-100 rounded-0'
              data-bs-dismiss='modal'
              id='closeModalForm'
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddVAT;
